import {ValueObject} from '@s-ui/domain'

import {VideoResourcesValueObject} from './VideoResourcesValueObject.js'

export class VideosResourcesValueObject extends ValueObject {
  #videos

  static VIDEO_RESOURCE_TYPE = 'VIDEO'

  constructor({videos}) {
    super()
    this.#videos = videos
  }

  static createFromListingApi({videos}) {
    return new VideosResourcesValueObject({
      videos: videos.map(video =>
        VideoResourcesValueObject.createFromLiterals({
          autoPlay: video.autoPlay,
          externalId: video.externalId,
          position: video.position,
          rovider: video.provider,
          url: video.url
        })
      )
    })
  }

  get videos() {
    return this.#videos.map(video => video.value)
  }

  get value() {
    return this.videos
  }
}
